export default class DtoMaterielCampaign {
    constructor(obj) {
        this.id = obj.id || obj.equipmentId
    }
}